import React from "react"
import { navigate } from "gatsby"
import { Modal } from 'react-overlays'
import Layout from "../components/layout"
import SEO from "../components/seo"
import DatiUtente from "../components/dati-utente"
import ReportFatturazione from "../components/report-fatturazione"
import RiepilogoReport from "../components/riepilogo-report"
import ModalitaPagamentoReport from "../components/modalita-pagamento-report"
import validateReportForm from '../utility/reportValidation'
import { createSessionReport, sendReportEmails } from '../utility/rest'
import { FormattedMessage } from "react-intl"
import { translatePage } from '../utils'


class ReportIICPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      surname: '',
      tipo: 'azienda',
      email: '',
      fiscalCode: '',
      street: '',
      number: '',
      cap: '',
      city: '',
      province: '',
      partitaIva: '',
      businessName: '',
      codiceFatturazione: '',
      pec: '',
      companyEmail: '',
      iva: 'true',
      newsletter: false,
      privacyInfo: false,
      privacyData: false,
      payment: null,
      errors: [],
      loading: false,
      stripe: null
    }
  }
  onChange(e) {
    const { name, type, value, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value
    }, () => {
      if (this.state.tipo === 'privato' && this.state.iva !== 'true'){
        this.setState({
          iva: 'true'
        }, () => this.validateOnChange())
      }else{
        this.validateOnChange();
      }
    });
  }
  validateOnChange() {
    if (this.state.errors.length) {
      const errors = validateReportForm(this.state);
      this.updateErrors(errors);
    }
  }
  updateErrors(errors) {
    console.warn('Validation errors: ', errors);
    return new Promise((resolve, reject) => {
      this.setState({
        errors
      }, resolve);
    });
  }
  async submitData(e) {
    e.preventDefault();
    const {pageContext: {locale}} = this.props;
    const errors = validateReportForm(this.state, locale);
    if (errors.length > 0) {
      this.updateErrors(errors).then(this.navigateToFirstError);
      return;
    }
    //FOR TESTING
    // this.setState({
    //   loading: true
    // }, () => {
    // setTimeout(() => {
    //   this.setState({loading: false})
    //   }, 2000);
    // });
    // return;

    this.setState({
      loading: true
    });

    const requestData = {...this.state, locale };
    
    if (this.state.payment === 'card') {
      try {
        const { session: { id: sessionId }, purchaseHash } = await createSessionReport(requestData);
        window.sessionStorage.setItem('purchaseHash', purchaseHash);
        const { error } = await this.state.stripe.redirectToCheckout({ sessionId });
        if (error) {
          console.warn('Error with checkout: ', error);
        }
      } catch (err) {
        console.error(err);
      }
      this.setState({
        loading: false
      });
    } else {
      try {
        const result = await sendReportEmails(requestData);
        console.log('result: ', result);
        this.setState({
          loading: false
        });
        navigate(translatePage('/grazie-dell-acquisto-report/', locale));
      } catch (err) {
        console.error(err);
        this.setState({
          loading: false
        });
      }
    }
  }
  navigateToFirstError() {
    let firstErrorElement = null;
    const errorElements = document.querySelectorAll(`.field--error`);
    if (errorElements.length) {
      firstErrorElement = errorElements[0];
    }
    if (firstErrorElement) {
      firstErrorElement.scrollIntoView();
    } else {
      console.warn(`Validation error detected, but couldn't scroll to element`);
    }
  }
  componentDidMount() {
    if (window.Stripe) {
      const stripe = window.Stripe(process.env.GATSBY_STRIPE_PUBLIC_KEY);
      this.setState({ stripe });
    }
  }
  renderBackdrop(props) {
    return <div {...props} className="modal-bg" />;
  }
  render() {
    const { pageContext: {locale}} = this.props;
    const { payment, loading, errors } = this.state;
    return (
      <Layout locale={locale}>
        <SEO title="Acquista report IIC 2020" />
        <div className="event-wrapper">
          <section className="acquista pb-5 mb-5">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                  <h1 className="section__title">
                    <FormattedMessage id="acquista-report-2020"/>
                  </h1>
                </div>
              </div>
              <DatiUtente utente={{...this.state }} errors={errors} onChange={(e) => this.onChange(e)} />
              <ReportFatturazione data={{ ...this.state }} onChange={e => this.onChange(e)} locale={locale} />
              <RiepilogoReport iva={this.state.iva}/>
              <ModalitaPagamentoReport payment={payment} onChange={e => this.onChange(e)} errors={errors} locale={locale} />
              <div className="row">
                <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
                  <button onClick={e => this.submitData(e)} className="btn-cta btn-style-2 btn-buy" disabled={loading}>
                    <FormattedMessage id="vai al pagamento"/>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Modal
          aria-labelledby="modal-label"
          show={loading}
          className="modal-box modal-box--white"
          renderBackdrop={this.renderBackdrop}
        >
          <div>
            <div className="lds-roller">
              <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            </div>
            {payment === 'card' && (
              <p>
                <FormattedMessage id="payment-redirect" />
              </p>
            )}
          </div>
        </Modal>
      </Layout >
    );
  }
}

export default ReportIICPage;
